<template>
  <div class="send-code">
    <div class="content">
      <div class="tabbar"><span class="iconfont" @click="handleGo()">{{'\ue682'}}</span></div>
      <div class="title">
        <div>{{loginFlag ? '输入验证码' : '密码登录'}}</div>
      </div>
      <div class="phone" v-if="loginFlag">
        <span>验证码已发送至手机 : </span>
        <span>{{setPhone(this.phone)}}</span>
      </div>
      <div class="phone" v-else>
        <div>您已切换成账号密码登录，请输入密码</div>
      </div>
<!-- 验证码 -->
      <div v-if="loginFlag">
        <div class="input-code">
        <div>
          <!-- 验证码输入框 -->
          <van-password-input
            :value="value"
            :mask="false"
            gutter="18"
            :focused="showKeyboard"
            @focus="showKeyboard = true"
          />
          <!-- 数字键盘 -->
          <van-number-keyboard
            v-model="value"
            :show="showKeyboard"
            @blur="showKeyboard = false"
          />
        </div>
        </div>
      </div>
<!-- 密码登录 -->
      <div v-else class="passwordLogin">
        <div class="login-title">密码</div>
        <div><input type="password" placeholder="请输入密码" v-model="login.password"/></div>
      </div>
      <div :class="['change-title',canClick ? 'send-in' : 'get-code']">
        <div v-if="loginFlag" @click="canClick ? getResetTestCode() : null">{{buttonTitle}} </div>
        <div v-else>{{''}}</div>
        <div @click="handleChangeTitle()">{{loginTitle}}</div>
      </div>
      <div v-if="loginFlag" :class="['next-step',value.length > 5 ? '' : 'disabled-button']" @click="value.length > 5 ? handleClick() : handleClick('wrong') ">
        下一步
      </div>
      <div v-else :class="['next-step',testPhoneAndPwd ? '' : 'disabled-button']" @click="testPhoneAndPwd ? handleClick() : handleClick('wrong') ">
        下一步
      </div>
    </div>
  </div>
</template>
<script>
import { localStorage, aesDoEncrypt } from '@utils/basicUtil'
import { NumberKeyboard, PasswordInput, Notify } from 'vant'
import { accountRequest, ukeyBoxRequest } from '@services'
export default {
  data () {
    return {
      ukeyBox: {},
      login: {
        phone: '',
        password: '',
        account: '',
        loginType: '2',
        captcha: ''
      },
      loginTitle: '切换密码登录',
      loginFlag: true,
      phone: '',
      value: '',
      code: '',
      timer: null,
      isPhone: false,
      buttonTitle: '获取验证码',
      canClick: true,
      showKeyboard: false
    }
  },
  async mounted () {
    if (sessionStorage.ukeyBox) {
      let ukeyBox = JSON.parse(sessionStorage.ukeyBox)
      this.ukeyBox = { ...ukeyBox }
      this.phone = ukeyBox.phone
      this.login.phone = ukeyBox.phone
      this.getResetTestCode()
    }
  },
  watch: {
    value (v, old) {
      if (v.length === 6) {
        this.showKeyboard = false
      }
      if (v.length > 6) {
        this.value = old
      }
    }
  },
  computed: {
    setPhone () {
      return function (phone) {
        return phone.substr(0, 3) + '****' + phone.substr(7)
      }
    },
    testPhoneAndPwd () {
      if (this.login.phone.length !== 11) {
        return false
      }
      if (this.login.password.length < 6 || this.login.password.length > 16) {
        return false
      } else {
        return true
      }
    }
  },
  methods: {
    async changeCurrentCompany (company) {
      const data = await accountRequest.company.changeCurrentCompany({ companyId: company.id })
      const detailData = await accountRequest.company.getCompanyDetail({}, { id: company.id })
      if (data.success) {
        localStorage.set('X-C-Token', data.result)
      } else {
        Notify({ type: 'danger', message: data.message })
      }
      if (detailData.success) {
        const resCompany = detailData.result
        localStorage.set('companyId', resCompany.id)
        localStorage.set('companyName', resCompany.name)
        localStorage.set('invoiceLimits', resCompany.companyInfoResponse.invoiceType ? resCompany.companyInfoResponse.invoiceType.split(',').sort((a, b) => a - b).join(',') : '')
        localStorage.set('showTaxSign', resCompany.companyInfoResponse.showTaxSign)
        this.$store.commit('user/changeCompany', resCompany)
      } else {
        Notify({ type: 'danger', message: detailData.message })
      }
    },
    async getCompanies () {
      const postData = {
        size: 1
      }
      const data = await accountRequest.company.getCompanyList(postData)
      if (data.success) {
        const defaultCompany = data.result.currentCompany ? data.result.currentCompany : data.result.records[0]
        if (!defaultCompany) {
          Notify({ type: 'danger', message: '您的账号没有关联公司，请联系业务人员操作' })
        }
        this.changeCurrentCompany(defaultCompany)
      } else {
        if (data.success === false) {
          Notify({ type: 'danger', message: data.message })
        }
      }
    },
    handleGo () {
      this.$router.go(-1)
    },
    handleChangeTitle () {
      if (this.loginFlag) {
        this.loginTitle = '切换验证码登录'
        this.loginFlag = false
        this.login = {
          phone: this.phone,
          password: '',
          account: '',
          loginType: '1',
          captcha: ''
        }
      } else {
        this.loginTitle = '切换密码登录'
        this.loginFlag = true
        this.login = {
          phone: this.phone,
          password: '',
          account: '',
          loginType: '2',
          captcha: ''
        }
      }
    },
    async handleClick (wrong) {
      if (wrong) {
        return Notify({ type: 'danger', message: '输入错误,请重新输入' })
      }
      let newPhone = this.phone
      // 此处判断是新用户还是老用户
      let userFlag = await ukeyBoxRequest.ukeyBox.getUserExist({
        phone: newPhone
      })
      if (userFlag.success) {
        // 如果存在直接跳转到, 绑定终端页面, 老用户在这里登录
        if (!userFlag.result) {
          Notify({ type: 'danger', message: '用户不存在,即将跳转到注册页面!' })
          return setTimeout(() => {
            this.$router.push({ path: '/ukey/set-password' })
          }, 2000)
        }
      } else {
        return Notify({ type: 'danger', message: userFlag.message })
      }
      // 如果走到这里证明你是老用户!
      if (this.loginFlag) {
        let data = await ukeyBoxRequest.ukeyBox.useAccountLogin({
          phone: newPhone,
          captcha: this.value,
          loginType: 2
        })
        if (data.success) {
          Notify({ type: 'success', message: '登录成功' })
          localStorage.set('X-Access-Token', data.result)
          this.getCompanies()
          return setTimeout(() => {
            this.$router.push({ path: '/ukey/binding' })
          }, 1000)
        } else {
          return Notify({ type: 'danger', message: data.message })
        }
      } else {
        this.login.account = this.login.phone
        this.login.password = aesDoEncrypt(this.login.password, true)
        const data = await accountRequest.login.login(this.login)
        if (data.success) {
          Notify({ type: 'success', message: '登录成功' })
          localStorage.set('X-Access-Token', data.result)
          this.getCompanies()
          setTimeout(() => {
            this.$router.push({ path: '/ukey/binding' })
          }, 1000)
        } else {
          Notify({ type: 'danger', message: data.message })
        }
      }
    },
    testPhone () {
      let phone = this.phone
      if (!/^1[3456789]\d{9}$/.test(phone.trim())) {
        Notify({ type: 'danger', message: '手机号格式不正确' })
      } else {
        this.isPhone = true
      }
    },
    testCodeTime () {
      let timeDown = 60
      this.timer = setInterval(() => {
        if (timeDown === 0) {
          clearInterval(this.timer)
          this.canClick = true
          this.buttonTitle = '发送验证码'
        } else {
          this.buttonTitle = timeDown + '秒后重试'
          this.canClick = false
          timeDown--
        }
      }, 1000)
    },
    async getResetTestCode () {
      this.testPhone()
      if (this.isPhone === true) {
        this.testCodeTime()
        const data = await ukeyBoxRequest.ukeyBox.sendCheckCode({
          phone: this.phone
        })
        if (data.success) {
          Notify({ type: 'success', message: '验证码已发送' })
        } else {
          clearInterval(this.timer)
          this.canClick = true
          Notify({ type: 'danger', message: data.message })
        }
      }
    }
  },

  components: {
    [NumberKeyboard.name]: NumberKeyboard,
    [PasswordInput.name]: PasswordInput,
    [Notify.name]: Notify
  }
}
</script>
<style scoped lang="less" src="./style.less"></style>
